import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import Layout from "../../layout/Layout";
import {
  statusMasterAPI,
  LabourAttandenceAPI,
  projectMasterAPI,
  labourWagesAPI,
  purchaseOrderAPI,
} from "../../config";

//form imports
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";

import axios from "axios";
import { config, _numberOnly } from "../../config";
import { AlertMessage } from "../../components/AlertMessage";
import { _getDropdownListData } from "../../service";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { MobileDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tabs from "@mui/material/Tabs";
import TabPanel from "@mui/lab/TabPanel";
import { styled } from "@mui/material/styles";
import { Container } from "@mui/material";
import { subDays, differenceInDays, startOfWeek, compareAsc } from "date-fns";
import * as XLSX from "xlsx";
import DescriptionIcon from "@mui/icons-material/Description";
import { Tooltip as ReactTooltip } from "react-tooltip";

import MuiLink from "@mui/material/Link";

// --- Labour hours -> day attribution ---------------------------------------
// The labour day is derived from hours worked (a full day = 8h):
//   >= 8h           -> full day  (pay the full-day rate; capped at 1 day, no OT)
//   >= 4h and < 8h  -> half day  (pay the half-day rate)
//   < 4h            -> pro-rated (hours / 8 x full-day rate)
// We keep the existing full_day_count / half_day_count columns so the stored
// proc + reports are unchanged: a partial (<4h) day is stored as a fractional
// full_day_count. NOTE: 8h exactly counts as a FULL day (full day = 8h).
const FULL_DAY_HOURS = 8;
const HALF_DAY_MIN_HOURS = 4;

function deriveLabourDay(hours, fullDayAmount, halfDayAmount) {
  const h = Number(hours) || 0;
  const full = Number(fullDayAmount) || 0;
  const half = Number(halfDayAmount) || 0;
  if (h <= 0) {
    return { full_day_count: 0, half_day_count: 0, line_total: 0, label: "-" };
  }
  if (h >= FULL_DAY_HOURS) {
    return { full_day_count: 1, half_day_count: 0, line_total: full, label: "Full day" };
  }
  if (h >= HALF_DAY_MIN_HOURS) {
    return { full_day_count: 0, half_day_count: 1, line_total: half, label: "Half day" };
  }
  const fraction = h / FULL_DAY_HOURS;
  return {
    full_day_count: Math.round(fraction * 100) / 100,
    half_day_count: 0,
    line_total: Math.round(full * fraction),
    label: `${h}h (partial)`,
  };
}

// Best-effort reverse mapping so existing saved rows populate the Hours field.
// Legacy rows with counts > 1 (multiple labourers) can't map to a single hours
// value; those keep their stored line_total until the Hours field is edited.
function hoursFromCounts(row) {
  const full = Number(row.full_day_count) || 0;
  const half = Number(row.half_day_count) || 0;
  if (full >= 1) return FULL_DAY_HOURS;
  if (half >= 1) return HALF_DAY_MIN_HOURS;
  if (full > 0) return Math.round(full * FULL_DAY_HOURS * 100) / 100;
  return "";
}

const LabourAttend = () => {
  const navigate = useNavigate();

  const [employeeName, setemployeeName] = useState(0);
  const [employeeNames, setemployeeNames] = useState([]);
  const [employeeId, setEmployeeId] = useState(0);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [labourAttendanceData, setLabourAttendanceData] = useState([]);
  const [inputValues, setInputValues] = useState([
    {
      intNoOfLaboursFullDay: 0,
      intNoOfLaboursHalfDay: 0,
      intLabourType: 0,
      intAmount: 0,
      intLineTotal: 0,
    },
  ]);
  const [projectid, setProjectId] = useState(0);

  const [projectName, setProjectName] = useState(0);
  const [listProjects, setListProjects] = useState([]);
  const [fromDate, setFromDate] = React.useState(dayjs());
  const [toDate, setToDate] = React.useState(dayjs());
  const [date, setDate] = React.useState(dayjs());
  const [selectProject, setSelectProject] = useState(1);

  const [getReport, setGetReportData] = useState([]);

  const handleInputChange = (text, name, index) => {
    const newInputValues = [...inputValues];
    newInputValues[index][name] = text;
    setInputValues(newInputValues);
  };

  const childRef = useRef();

  const errors = "There was an error!";

  const onSubmit = async () => {
    const data = {
      txtEmployeeName: employeeName,
      intEmployeeID: employeeId,
      intProjectID: projectid,
      txtDate: date.format("YYYY-MM-DD"),
      txtAttendance: selectedEmployee,
      intType: 9,
    };

    // return;

    config.method = "POST";
    config.data = data;
    config.url = LabourAttandenceAPI;
    axios(config)
      .then(function (response) {
        const messageType = response.data.code === 500 ? "warning" : "success";
        if (response.data.message === "Labours attendance details updated") {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "Record has been updated successfully",
              messageType: messageType,
            })
          );
        } else {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: response.data.message,
              messageType: messageType,
            })
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onClickEmployee = async () => {
    const data = JSON.stringify({
      txtDate: date.format("YYYY-MM-DD"),
      intProjectID: projectid,
      intType: 8,
    });

    config.method = "POST";
    config.data = data;
    config.url = LabourAttandenceAPI;
    axios(config)
      .then(function (response) {
        if (response.data.result.length === 0) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "No Records found",
              messageType: "warning",
            })
          );
        }
        if (response.data.message == "Labours attandence project details") {
        }
        setProjectId(response.data.result[0].project_id);

        fetchPoWo(response.data.result[0].project_id);
        fetchContractors();
        // Populate the Hours field from the saved full/half-day counts so an
        // existing row can be re-edited in the new hours model.
        const rowsWithHours = (response.data.result || []).map((r) => ({
          ...r,
          hours: hoursFromCounts(r),
        }));
        setSelectedEmployee(rowsWithHours);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
 
  const selectDate = async () => {
    const today = new Date();
    const daysToFriday = (today.getDay() + 7 - 5) % 7; // days until last Friday
    const lastFriday = new Date(today.getTime() - daysToFriday * 86400000);
    return moment(lastFriday).format("YYYY-MM-DD");
  };

  const handleFromDate = async () => {
    setFromDate(await selectDate());
  };

  const calculateLineTotal = (data) => {
    let total = 0;
    data.forEach((item) => {
      total += item["Line Total"];
    });
    return total;
  };

  const setReportData = (data) => {
    const lineTotal = calculateLineTotal(data);
    setGetReportData([...data, { "Line Total": lineTotal }]);
  };

  const onSubmitProject = async (value) => {
    const data = JSON.stringify({
      intProjectID: projectName,
      txtFromDate:
        value === 2 ? await selectDate() : fromDate.format("YYYY-MM-DD"),
      txtToDate:
        value === 2
          ? moment().format("YYYY-MM-DD")
          : toDate.format("YYYY-MM-DD"),
      txtDate: moment().format("YYYY-MM-DD"),
      intType: 10,
    });

    config.method = "POST";
    config.data = data;
    config.url = LabourAttandenceAPI;

    axios(config)
      .then(function (response) {
        console.log(
          "⛔ ➡️ file: labourAttendence.jsx:223 ➡️ response:",
          response
        );

        // setProjectId(response.data.result[0].project_id);

        setGetReportData(response.data.result);

        const messageType = response.data.code === 500 ? "warning" : "success";

        if (value === 2) {
          // if weekly report button is clicked
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "Weekly Report generated successfully",
              messageType: messageType,
            })
          );
        } else {
          // if search button is clicked
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "Search Result generated successfully",
              messageType: messageType,
            })
          );
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  let tempRefs = useRef(false);

  useEffect(() => {
    // if (tempRefs.current === false) {
    // let data = {
    //   requestData: {
    //     intType: 7,
    //     txtDate: moment().format("YYYY-MM-DD"),
    //   },
    //   API: LabourAttandenceAPI,
    //   setData: setemployeeNames,
    // };
    // _getDropdownListData(data);

    let projectNamesData = {
      requestData: {
        // txtDate: moment().format("YYYY-MM-DD"),
        intType: 6,
      },
      API: projectMasterAPI,
      setData: setListProjects,
    };
    _getDropdownListData(projectNamesData);

    return () => {
      tempRefs.current = true;
    };
  }, []);

  //Work Type
  const [workType, setWorkType] = useState([]);
  const [txtWorkType, setTxtWorkType] = useState("");

  // Type of Work (status parent 108) — lumpsum/rate live here (matches mobile).
  const [workType108, setWorkType108] = useState([]);
  const [poWoOptions, setPoWoOptions] = useState([]);

  useEffect(() => {
    _getDropdownListData({
      requestData: { intType: 2, intParentId: 108 },
      API: statusMasterAPI,
      setData: setWorkType108,
    });
  }, []);

  // Fetch the selected project's purchase + work orders (order_type 1=PO, 2=WO).
  const fetchPoWo = (projectId) => {
    const data = JSON.stringify({
      txtOrderType: 0,
      txtCompanyName: 0,
      txtVendorName: 0,
      txtSearchString: "",
      txtPODate: "",
      txtSortDirection: "desc",
      intLimit: 1000,
      intOffset: 0,
      intType: 23,
    });
    axios({ ...config, method: "POST", data, url: purchaseOrderAPI })
      .then((res) => {
        const rows = res.data && res.data.data ? res.data.data : [];
        setPoWoOptions(
          rows
            .filter(
              (r) =>
                String(r.project_id) === String(projectId) && r.status !== 100
            )
            .map((r) => ({
              id: r.id,
              label: `${r.po_no || "Order #" + r.id} · ${
                Number(r.order_type) === 2 ? "WO" : "PO"
              }`,
            }))
        );
      })
      .catch((e) => {
        console.log(e);
        setPoWoOptions([]);
      });
  };

  // PO/WO applies to lumpsum & rate work (matched by name).
  const isPoWoType = (row) => {
    const item = workType108.find(
      (w) => String(w.id) === String(row.work_type)
    );
    const name = item && item.name ? String(item.name).toLowerCase() : "";
    return /rate|lump\s*sum/.test(name);
  };

  let tempRef = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false) {
      let data = {
        requestData: {
          intType: 2,
          intParentId: 46,
        },
        API: statusMasterAPI,
        setData: setWorkType,
      };
      _getDropdownListData(data);
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  // contractor name (labour wages)
  const [contractorNames, setContractorNames] = useState([]);

  useEffect(() => {
    if (tempRefs.current === false) {
      let data = {
        requestData: {
          intType: 3,
          intLimit: 1000,
        },
        API: labourWagesAPI,
        setData: setContractorNames,
      };
      _getDropdownListData(data);
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);
  
  const fetchContractors = (val) => {
   
    let data = {
      requestData: {
        intType: 3,
       
        intLimit: 1000,
      },
      API: labourWagesAPI,
      setData: setContractorNames,
    };
    _getDropdownListData(data);
  };

  const [salaryData, setSalaryData] = useState([]);
  const fetchContractorSalary = (val) => {
    let data = {
      requestData: {
        intType: 4,
        intID: val,
      },
      API: labourWagesAPI,
      setData: setSalaryData,
    };
    _getDropdownListData(data);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  function handleWeeklyReport() {
    // setToDate(new Date())
    let lastDate = new Date();
    let fromDate = new Date(
      lastDate.getTime() - ((lastDate.getDay() + 2) % 7) * 24 * 60 * 60 * 1000
    );
    //setFromDate(lastFriday)
    // onSubmitProject(fromDate,lastDate);
  }

  const reportData = getReport.map((item) => {
    const { id, ...rest } = item;
    Object.keys(rest).forEach((key) => {
      if (key !== "Total Working Hours") {
        rest[moment(key).format("DD-MM-YYYY")] = rest[key];
        delete rest[key];
      } else {
        rest["Total Working Hours"] = moment
          .duration(rest["Total Working Hours"], "minutes")
          .format("h:mm", { trim: false });
      }
    });
    return rest;
  });

  const exportToExcel = () => {
    const reportData = getReport.map((item) => {
      const { id, ...rest } = item;
      const modifiedRest = Object.keys(rest).reduce((acc, key) => {
        const newKey = key.replace(/count/i, "");
        acc[newKey] = rest[key];
        return acc;
      }, {});
      // Include employee name in export if present and remove raw keys that would duplicate it
      modifiedRest['Employee Name'] = rest.employee_name || rest.Employee || rest['Employee Name'] || rest.created_by || "";
      // remove raw employee keys to avoid duplicate columns in Excel
      ['employee_name','Employee','Employee Name'].forEach(k => delete modifiedRest[k]);
      modifiedRest.Date = moment(modifiedRest.Date).format("YY-MM-DD");
      return modifiedRest;
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(reportData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "report");
    XLSX.writeFile(
      workbook,
      "KG-labour-attendance-report- " +
        moment().format("DD/MM/YYYY, h:mm:ss") +
        " hrs.xlsx"
    );
  };

  // Calculate column count and dynamic min width so table can scroll horizontally
  const reportColumnCount = getReport && getReport[0] ? (Object.keys(getReport[0]).filter((k) => k !== 'id').length + 1) : 0; // +1 for Employee Name column
  const tableMinWidth = reportColumnCount ? Math.max(700, reportColumnCount * 140) : 700;

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getTotal = () => {
    let total = 0;
    getReport.forEach((item) => {
      total += item["Line Total"] || 0;
    });
    return total;
  };

  //Disable the submit button
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const handleButtonClick = () => {
    setIsButtonClicked(true);
  };

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <AlertMessage ref={childRef} />
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Labour Attendance Report
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <MuiLink underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </MuiLink>
              <Typography color="text.primary">Reports</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>

          <Grid className="form_design">
            <Grid>
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                    >
                      <Tab label="Edit Labour Attendance" value="1" />
                      <Tab label="Labour Attendance Report" value="2" />
                    </TabList>
                  </Box>
                  <TabPanel value="1">
                    <Grid
                      textAlign="center"
                      item
                      className="form-lable"
                      xs={12}
                      lg={12}
                      md={12}
                    ></Grid>
                    <Box width="100%">
                      <Container maxWidth="lg">
                        <Grid
                          container
                          spacing={3}
                          justifyContent="space-between"
                        >
                          <Grid item xs={12} lg={6} md={6}>
                            <FormControl fullWidth>
                              <InputLabel id="demo-simple-select-label">
                                Project
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={projectid}
                                label="Project"
                                onChange={(e) => {
                                  setProjectId(e.target.value);
                                }}
                              >
                                {listProjects.length !== 0 ? (
                                  listProjects.map((row) => {
                                    return (
                                      <MenuItem key={row.id} value={row.id}>
                                        {row.name}
                                      </MenuItem>
                                    );
                                  })
                                ) : (
                                  <MenuItem value="">
                                    No projects available
                                  </MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} lg={6} md={6}>
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              format="DD-MM-YYYY"
                            >
                              <MobileDatePicker
                                label="Date"
                                value={date}
                                inputFormat="DD/MM/YYYY"
                                fullWidth
                                onChange={(e) => {
                                  setDate(e);
                                }}
                                renderInput={(params) => (
                                  <TextField {...params} fullWidth />
                                )}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid container justifyContent="flex-end">
                            <Grid item>
                              {isButtonClicked ? null : (
                                <Button
                                  style={{ marginTop: "20px" }}
                                  variant="primary"
                                  className={`btn-primary`}
                                  type="submit"
                                  onClick={(e) => {
                                    // handleButtonClick();
                                    setProjectId(e.target.value);
                                    onClickEmployee(e.target.value);
                                  }}
                                >
                                  Search
                                </Button>
                              )}
                            </Grid>
                          </Grid>
                          {selectProject !== 0 &&
                            selectedEmployee.length > 0 &&
                            selectedEmployee.map((row, index) => {
                             
                              const handleHalfDayCountChange = (e) => {
                                const newSelectedEmployee = [
                                  ...selectedEmployee,
                                ];
                                newSelectedEmployee[index].half_day_count =
                                  parseInt(e.target.value);
                                setSelectedEmployee(newSelectedEmployee);
                              };

                              const handleFullDayCountChange = (e) => {
                                const newSelectedEmployee = [
                                  ...selectedEmployee,
                                ];

                                newSelectedEmployee[index].full_day_count =
                                  parseInt(e.target.value);

                                setSelectedEmployee(newSelectedEmployee);
                              };

                              // Recompute the line total from the employee buckets:
                              // full-day + half-day + partial employees (each partial
                              // pro-rated by their hours). Writes the existing columns
                              // so reports keep working; partial_hours / partial_count
                              // go into the new columns (see the SP hand-off).
                              const recomputeRow = (r) => {
                                const num = (v) =>
                                  isNaN(parseInt(v)) ? 0 : parseInt(v);
                                const flt = (v) =>
                                  isNaN(parseFloat(v)) ? 0 : parseFloat(v);
                                const fullRate = Number(r.full_day_amount) || 0;
                                const halfRate = Number(r.half_day_amount) || 0;
                                const partialCount = num(r.partial_count);
                                const partialPer =
                                  partialCount > 0
                                    ? deriveLabourDay(
                                        flt(r.partial_hours),
                                        fullRate,
                                        halfRate
                                      ).line_total
                                    : 0;
                                r.line_total =
                                  num(r.full_day_count) * fullRate +
                                  num(r.half_day_count) * halfRate +
                                  partialCount * partialPer;
                              };

                              const setField = (field, val) => {
                                const next = [...selectedEmployee];
                                next[index][field] = val;
                                recomputeRow(next[index]);
                                setSelectedEmployee(next);
                              };

                              const handleAmountCountChange = (e) => {
                                const newSelectedEmployee = [
                                  ...selectedEmployee,
                                ];
                                newSelectedEmployee[index].amount =
                                  e.target.value;
                                setSelectedEmployee(newSelectedEmployee);
                              };

                              const newWorkType = (value, index) => {
                                const newSelectedEmployee = [
                                  ...selectedEmployee,
                                ];
                                newSelectedEmployee[index].labour_type = value;
                                setSelectedEmployee(newSelectedEmployee);
                              };

                              const updateLineTotal = (e, t) => {
                                const newSelectedEmployee = [
                                  ...selectedEmployee,
                                ];

                                console.log(
                                  "newSelectedEmployee",
                                  newSelectedEmployee
                                );

                                // const lineTotal =
                                //   parseInt(newSelectedEmployee[index].amount) *
                                //     parseInt(
                                //       newSelectedEmployee[index].full_day_count
                                //     ) +
                                //   parseInt(
                                //     newSelectedEmployee[index].amount / 2
                                //   ) *
                                //     parseInt(
                                //       newSelectedEmployee[index].half_day_count
                                //     );

                                let lineTotal;

                                if (t == "half") {
                                  lineTotal =
                                    newSelectedEmployee[index].full_day_amount *
                                      newSelectedEmployee[index]
                                        .full_day_count +
                                    newSelectedEmployee[index].half_day_amount *
                                      e.target.value;
                                } else {
                                  lineTotal =
                                    newSelectedEmployee[index].full_day_amount *
                                      e.target.value +
                                    newSelectedEmployee[index].half_day_amount *
                                      newSelectedEmployee[index].half_day_count;
                                }

                                newSelectedEmployee[index].line_total =
                                  lineTotal;

                                setSelectedEmployee(newSelectedEmployee);
                              };

                              const handleContractorName = (value, index) => {
                                const newSelectedEmployee = [
                                  ...selectedEmployee,
                                ];
                                newSelectedEmployee[index].labour_name = value;
                                setSelectedEmployee(newSelectedEmployee);
                              };

                              return (
                                <>
                                  <Grid
                                    textAlign="center"
                                    item
                                    className="form-lable"
                                    xs={12}
                                    lg={12}
                                    md={12}
                                  ></Grid>
                                  <Grid container spacing={1}>
                                    <Grid item xs={3}>
                                      <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                          Work Type
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={row.labour_type}
                                          label="Work Type"
                                          onChange={(e) => {
                                            setTxtWorkType(e.target.value);
                                            newWorkType(e.target.value, index);
                                          }}
                                        >
                                          {workType.map((option) => (
                                            <MenuItem
                                              key={option.id}
                                              value={option.id}
                                            >
                                              {option.name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>

                                    <Grid item xs={3}>
                                      <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                          Type of Work
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          value={row.work_type || ""}
                                          label="Type of Work"
                                          onChange={(e) =>
                                            setField("work_type", e.target.value)
                                          }
                                        >
                                          {workType108.map((option) => (
                                            <MenuItem
                                              key={option.id}
                                              value={option.id}
                                            >
                                              {option.name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>

                                    {isPoWoType(row) && (
                                      <Grid item xs={3}>
                                        <FormControl fullWidth>
                                          <InputLabel id="demo-simple-select-label">
                                            PO / WO
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-label"
                                            value={row.po_wo_id || ""}
                                            label="PO / WO"
                                            onChange={(e) =>
                                              setField("po_wo_id", e.target.value)
                                            }
                                          >
                                            {poWoOptions.length === 0 ? (
                                              <MenuItem value="" disabled>
                                                No PO / WO for this project
                                              </MenuItem>
                                            ) : (
                                              poWoOptions.map((o) => (
                                                <MenuItem key={o.id} value={o.id}>
                                                  {o.label}
                                                </MenuItem>
                                              ))
                                            )}
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                    )}

                                    {/* contractor */}
                                    <Grid item xs={3}>
                                      <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">
                                          Contractor name
                                        </InputLabel>
                                        <Select
                                          labelId="demo-simple-select-label"
                                          id="demo-simple-select"
                                          value={row.labour_name}
                                          label="Contractor name"
                                          disabled
                                          onChange={(e) => {
                                            // setTxtWorkType(e.target.value);
                                            // newWorkType(e.target.value, index);
                                            handleContractorName(
                                              e.target.value,
                                              index
                                            );
                                            fetchContractorSalary(
                                              e.target.value
                                            );
                                          }}
                                        >
                                          {contractorNames.map((option) => (
                                            <MenuItem
                                              key={option.id}
                                              value={option.id}
                                            >
                                              {option.labour_name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>

                                      {/* <TextField
                                        value={row.labour_name}
                                        name="contractor-name"
                                        type="text"
                                        label="Contractor name"
                                        fullWidth
                                        InputProps={{
                                          readOnly: true,
                                        }}
                                        onChange={(e) => {
                                          // handleHalfDayCountChange(e);
                                          // updateLineTotal(e);
                                        }}
                                      /> */}
                                    </Grid>

                                    <Grid item xs={6} md={3}>
                                      <TextField
                                        value={row.full_day_count ?? ""}
                                        name="full_day_count"
                                        type="number"
                                        label="Full-day employees"
                                        fullWidth
                                        inputProps={{ min: 0 }}
                                        onChange={(e) =>
                                          setField("full_day_count", e.target.value)
                                        }
                                      />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                      <TextField
                                        value={row.half_day_count ?? ""}
                                        name="half_day_count"
                                        type="number"
                                        label="Half-day employees"
                                        fullWidth
                                        inputProps={{ min: 0 }}
                                        onChange={(e) =>
                                          setField("half_day_count", e.target.value)
                                        }
                                      />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                      <TextField
                                        value={row.partial_hours ?? ""}
                                        name="partial_hours"
                                        type="number"
                                        label="Partial hours (under 4h)"
                                        fullWidth
                                        inputProps={{ min: 0, step: 0.5 }}
                                        onChange={(e) =>
                                          setField("partial_hours", e.target.value)
                                        }
                                      />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                      <TextField
                                        value={row.partial_count ?? ""}
                                        name="partial_count"
                                        type="number"
                                        label="Partial employees"
                                        fullWidth
                                        inputProps={{ min: 0 }}
                                        onChange={(e) =>
                                          setField("partial_count", e.target.value)
                                        }
                                        helperText="hours ÷ 8 × full-day rate"
                                      />
                                    </Grid>
                                    <Grid item xs={2}>
                                      <TextField
                                        value={row.full_day_amount}
                                        name="amount"
                                        type="number"
                                        label="Full day amount"
                                        fullWidth
                                        disabled
                                        onChange={(e) => {
                                          // handleAmountCountChange(e);
                                          // updateLineTotal(e);
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={2}>
                                      <TextField
                                        value={row.half_day_amount}
                                        name="amount"
                                        type="number"
                                        label="Half day amount"
                                        disabled
                                        fullWidth
                                        onChange={(e) => {
                                          // handleAmountCountChange(e);
                                          // updateLineTotal(e);
                                        }}
                                      />
                                    </Grid>
                                    <Grid item xs={3}>
                                      {/* <TextField id="outlined-basic" label="Outlined"  /> */}
                                      <TextField
                                        value={row.line_total}
                                        type="text"
                                        label="Line Total"
                                        variant="outlined"
                                        disabled
                                      />
                                    </Grid>
                                  </Grid>
                                </>
                              );
                            })}
                          {selectedEmployee.length > 0 && (
                            <Grid
                              item
                              xs={12}
                              lg={12}
                              md={12}
                              textAlign="right"
                            >
                              <Button
                                variant="primary"
                                className={`btn-primary`}
                                type="submit"
                                onClick={(e) => {
                                  onSubmit();
                                }}
                              >
                                Submit
                              </Button>
                            </Grid>
                          )}
                        </Grid>
                      </Container>
                    </Box>
                  </TabPanel>

                  {/* labour attendance report */}
                  <TabPanel value="2">
                    <Grid container spacing={3}>
                      <Grid
                        textAlign="center"
                        item
                        className="form-lable"
                        xs={12}
                        lg={6}
                        md={6}
                      ></Grid>
                      <Grid
                        textAlign="right"
                        item
                        className="form-lable"
                        xs={12}
                        lg={6}
                        md={6}
                      ></Grid>

                      <Grid item xs={12} lg={6} md={6}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Project
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={projectName}
                            label="Project"
                            onChange={(e) => {
                              setProjectName(e.target.value);
                            }}
                          >
                            {listProjects.length !== 0 ? (
                              listProjects.map((row) => {
                                return (
                                  <MenuItem key={row.id} value={row.id}>
                                    {row.name}
                                  </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem value="">
                                No projects available
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={3} md={3}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          format="DD-MM-YYYY"
                        >
                          <MobileDatePicker
                            label="From Date"
                            value={fromDate}
                            inputFormat="DD/MM/YYYY"
                            fullWidth
                            onChange={(e) => {
                              setFromDate(e);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} lg={3} md={3}>
                        <LocalizationProvider
                          dateAdapter={AdapterDayjs}
                          format="YYYY-MM-DD"
                        >
                          <MobileDatePicker
                            label="To Date"
                            value={toDate}
                            inputFormat="DD/MM/YYYY"
                            fullWidth
                            onChange={(e) => {
                              setToDate(e);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} fullWidth />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} lg={12} md={12} textAlign="right">
                        <Button
                          style={{ marginRight: "8px" }}
                          variant="primary"
                          className={`btn-primary`}
                          type="submit"
                          onClick={() => {
                            onSubmitProject(2);
                            handleFromDate();
                          }}
                        >
                          Weekly Report
                        </Button>

                        <Button
                          variant="primary"
                          className={`btn-primary`}
                          type="submit"
                          onClick={() => {
                            onSubmitProject(1);
                          }}
                        >
                          Search
                        </Button>
                      </Grid>
                      <Grid
                        className="excel_button"
                        item
                        xs={12}
                        lg={12}
                        md={12}
                      >
                        <Button
                          // className="btn-primary"
                          color="success"
                          variant="contained"
                          onClick={() => exportToExcel()}
                          startIcon={<DescriptionIcon />}
                          sx={{
                            marginTop: "1rem",
                            marginRight: "1rem",
                            borderRadius: "5px !important",
                          }}
                        >
                          Export to Excel
                        </Button>
                      </Grid>

                      <Grid
                        textAlign="center"
                        item
                        className="form-lable"
                        xs={12}
                        lg={12}
                        md={12}
                      ></Grid>

                      {getReport.length > 0 && (
                        <Grid sx={{ overflowX: 'auto', width: '100%' }}>
                          <p style={{ fontWeight: "bold" }}>
                            Total Amount :{" "}
                            <span
                              style={{
                                color: "#155d27",
                                fontWeight: "bold",
                                backgroundColor: "#c9ffe2",
                                padding: "10px",
                                borderRadius: "10px",
                                textAlign: "center",
                              }}
                            >
                              ₹ {calculateLineTotal(getReport)}
                            </span>
                          </p>
                            <TableContainer component={Paper} sx={{ width: '100%', overflowX: 'auto', display: 'block' }}>
                              <Table
                                sx={{ minWidth: tableMinWidth, width: '100%' }}
                                aria-label="customized table"
                                stickyHeader
                              >
                                <TableHead>
                                  <TableRow>
                                    <StyledTableCell key="Employee Name" sx={{ minWidth: 160, whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                      Employee Name
                                    </StyledTableCell>
                                    {Object.keys(getReport[0]).filter((k) => !['id','employee_name','Employee','Employee Name'].includes(k)).map((key) => (
                                      <StyledTableCell key={key} sx={{ minWidth: 140, whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                        {key.replace(/\bcount\b/g, "")}
                                      </StyledTableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {getReport.map((item) => (
                                    <TableRow key={item.id}>
                                      <TableCell key={`employee_name_${item.id}`} sx={{ minWidth: 160, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '6px 16px', fontWeight: 500 }}>
                                        {item.employee_name || item.Employee || item['Employee Name'] || item.created_by || "-"}
                                      </TableCell>
                                      {Object.entries(item).map(([key, value]) => {
                                        if (!['id','employee_name','Employee','Employee Name'].includes(key)) {
                                          return (
                                            <TableCell
                                              key={key}
                                              sx={{ minWidth: 140, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '6px 16px' }}
                                              className={
                                                dayjs(key).format("MMM DD, YYYY") !== "Invalid date"
                                                  ? "text-center"
                                                  : key === "Total Working Hours"
                                                  ? "text-center"
                                                  : ""
                                              }
                                            >
                                              {/* {value === null
                                            ? "-"
                                            : key === "half_day_count" 
                                            ? value + '+h'
                                            : key === "full_day_count" 
                                            && `${value}f`
                                          } */}
                                              {value === null
                                                ? "-"
                                                : moment(value)
                                                    .subtract(2.3, "hours")
                                                    .format("DD-MM-YYYY") ===
                                                    "01-01-1970" ||
                                                  moment(value)
                                                    .subtract(2.3, "hours")
                                                    .format("DD-MM-YYYY") ===
                                                    "Invalid date"
                                                ? value
                                                : moment(value)
                                                    .subtract(2.3, "hours")
                                                    .format("DD-MM-YYYY")}
                                            </TableCell>
                                          );
                                        }
                                      }
                                    )}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                          </Grid>
                      )}
                    </Grid>
                  </TabPanel>
                </TabContext>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
};

export default LabourAttend;

// SET @sql = NULL;
// SELECT
//   GROUP_CONCAT(DISTINCT
//     CONCAT(
//       'MAX(IF(b.name = ''',
//       b.name,
//       ''', CONCAT(''('', half_day_count, ''H + '', full_day_count, ''F) '', ''x '', a.amount, '' RS'') , NULL)) AS "', b.name, ' count"'
//     )
//   ) INTO @sql
// FROM tbl_labour_attandence as a
// INNER JOIN tbl_status as b ON a.labour_type = b.id;

// SET @sql = CONCAT(
//   'SELECT c.name as "Project Name", a.created_at as Date, a.id, ',
//   @sql,
//   ', (a.line_total) as "Line Total" ',
//   'FROM tbl_labour_attandence as a ',
//   'INNER JOIN tbl_status as b ON a.labour_type = b.id ',
//   'INNER JOIN tbl_project_master as c ON a.project_id = c.id ',
//   'WHERE ((', intEmployeeID,' = created_by OR ', intEmployeeID,' = 0) AND (', intProjectID,' = project_id OR ', intProjectID,' = 0) AND (DATE(a.created_at) BETWEEN "', txtFromDate,'" AND "', txtToDate,'")) ',
//   'GROUP BY project_id'
// );

// PREPARE stmt FROM @sql;
// EXECUTE stmt;
// DEALLOCATE PREPARE stmt;
